import { useIntegrationManagement } from './useIntegrationManagement'
import NotFound from 'components/ErrorPages/NotFound'
import { IntegrationManagementHeader } from './IntegrationManagementHeader'
import { Panel, Flex, GridItem } from '@sequencehq/core-components'
import SpinnerContainer from 'components/Loading/SpinnerContainer'
import { IntegrationManagementActions } from './IntegrationManagementActions/IntegrationManagementActions'
import { IntegrationReconnectBanner } from './IntegrationReconnectBanner'
import { DefaultIntegrationManagementInspector } from './DefaultIntegrationManagementInspector'
import { useOAuthRedirectConnectionPolling } from 'Integrations/hooks/useOAuthRedirectConnectionPolling'

const defaultTemplateAreas = `
      "header"
      "actions"
      "content"
    `

const inspectorTemplateAreas = `
      "header header"
      "actions actions"
      "content inspector"
    `

export const IntegrationManagement = () => {
  const hook = useIntegrationManagement()
  useOAuthRedirectConnectionPolling()

  if (hook.loading) {
    return <SpinnerContainer />
  }

  if (!hook.integration || !hook.contentProps) {
    return <NotFound />
  }
  const ContentComponent = hook.integration.components.management
  const InspectorComponent =
    hook.integration.components.inspector ??
    DefaultIntegrationManagementInspector

  return (
    <Panel
      display="grid"
      gridTemplateRows={'auto auto 1fr'}
      gridTemplateColumns="1fr auto"
      gridTemplateAreas={
        InspectorComponent ? inspectorTemplateAreas : defaultTemplateAreas
      }
      width="100%"
      minWidth="808px"
      height="100%"
    >
      <GridItem gridArea="header">
        <IntegrationManagementHeader />
      </GridItem>
      <GridItem gridArea="actions">
        <IntegrationManagementActions />
      </GridItem>
      <GridItem
        gridArea="content"
        display="grid"
        gridTemplateColumns={'1fr auto'}
        overflow="auto"
      >
        <GridItem display="flex" justifyContent="center">
          <Flex
            width="100%"
            maxWidth="808px"
            flexDirection="column"
            gap="20px"
            alignItems="center"
            padding="16px"
          >
            <IntegrationReconnectBanner />
            <ContentComponent {...hook.contentProps} />
          </Flex>
        </GridItem>
      </GridItem>
      {/* `minHeight="0"` lets the inspector scroll instead of stretching the row — see the Inspector docs. */}
      <GridItem
        gridArea="inspector"
        display="flex"
        justifyContent="flex-end"
        minHeight="0"
      >
        <InspectorComponent {...hook.contentProps} />
      </GridItem>
    </Panel>
  )
}
